import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import WithdrawalTransactionIndex from "../../../../components/SidetabPages/Transaction/WithdrawalTransaction/WithdrawalTransactionIndex";

const WithdrawalTransaction = () => {
  return (
    <>
      <AnnouncementBar />
      <WithdrawalTransactionIndex />
    </>
  );
};
export default WithdrawalTransaction;
